module.exports = __webpack_public_path__ + "img/dataProcess.69856bf4.png";